import React from 'react';
import i18n from '../../i18n';
import { TableCell, Tooltip, Typography } from '@mui/material';

const styles = {
    controllerCell: {
        backgroundColor: '#F4F6F8',
        fontWeight: 'bold'
    },
    truncatedText: {
        cursor: 'pointer',
        overflow: 'hidden',
        userSelect: 'text',
        display: 'inline-block'
    }
};

export default class GridTextCell extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            isMobile: false
        };
    }
    componentDidMount() {
        const mql = window.matchMedia('(max-width:600px)');
        this.setState({ isMobile: mql.matches });
    }

    toggleExpand = () => {
        this.setState((prev) => ({ expanded: !prev.expanded }));
    };

    render() {
        const { id, translate, needStyle, show } = this.props.field;
        const rawValue = show ? this.props.value?.[show] : this.props.value;
        const value = translate ? i18n.t(`${translate}.${rawValue}`) : rawValue;
        const { expanded, isMobile } = this.state;

        const isLong = typeof value === "string" && value.length > 36;
        const shouldTruncate = isLong && !isMobile && !expanded;
        const displayText = shouldTruncate ? value.slice(0, 36) + "..." : value;


        const textComponent = (
            <Typography
                variant="body2"
                sx={shouldTruncate ? styles.truncatedText : undefined}
                onClick={isLong && !isMobile ? this.toggleExpand : undefined}
            >
                {displayText}
            </Typography>
        );
        const baseStyle = this.props.styles;

        return (
            <TableCell
                key={id}
                align="left"
                sx={{
                    ...(needStyle ? styles.controllerCell : {}),
                    ...baseStyle
                }}
            >
                {isLong && !expanded ? (
                    <Tooltip title={value}>{textComponent}</Tooltip>
                ) : (
                    textComponent
                )}
            </TableCell>
        );
    }
}
